import { Component, OnInit, Input, Output, OnChanges, SimpleChanges, EventEmitter } from '@angular/core';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
// services
import { MessageService } from '../../../../services/message.service';
import { MasterService } from '../../../../services/master.service';
import { StoreService } from '../../../../services/store.service';
import * as words from '../../../../services/language'
import { formatCurrency } from 'src/app/utils/format';
import moment from 'moment';
import { AutomationEntry } from 'src/app/models/automation-entry.model';

@Component({
    selector: 'recompute-modal',
    templateUrl: './recompute-modal.component.html',
    styleUrls: ['./recompute-modal.component.scss'],
    standalone: false
})
export class RecomputeModal implements OnInit, OnChanges {
    
    // A recent automation entry for computeTerms that gives basic details we need to recompute.
    @Input() entry: AutomationEntry

    /**
     * Unique internal identity of the terms associated with the recompute, if any. 
     * Recomputing a specific terms is more comprehensive.
    */
    @Input() termsId: number = 0
    
    // Currently selected language
    @Input() language: string = localStorage.getItem('language') ? localStorage.getItem('language') : 'EN'
    
    // Word replacements for each language.
    @Input() words: Object = words.language

    /** Indicates to the callee that the user chose to recompute the receivables and it was successful. */
    @Output() recomputed: EventEmitter<Object> = new EventEmitter()

    // Top level recompute form with basic details.
    protected form: FormGroup;

    /** */
    protected lotId: number = 0
    
    // Indicates whether the payoff is currently processing.
    protected processing: boolean = false

    constructor(private master: MasterService, private ms: MessageService, private store: StoreService, private fb: FormBuilder) { 
        this.form = this.fb.group({
            asOf: new FormControl<string>(moment().format('YYYY-MM-DD'), [Validators.required])
        })
    }

    ngOnInit() {
        this.lotId = parseInt(localStorage.getItem('lot') || this.store.lotSelected)
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (!changes) {
            return
        }

        const first = Object.values(changes).some(c => c.isFirstChange())
        if (first) {
            return
        }

        if (changes.entry) {
            if (!this.entry) {
                return
            }

            this.lotId = this.entry.lotId
        }
    }

    /**
     * 
     * @param e 
     * @returns 
     */
    protected recompute = (e: Event) => {
        if (e) {
            e.preventDefault()
        }

        // if (!this.entry) {
        //     return
        // }

        const asOf = this.form.get('asOf').value
        if (!asOf || (asOf.length <= 0)) {
            return
        }

        const payload = {
            asOf: encodeURIComponent(moment(asOf).format('YYYY-MM-DD')),
            lotId: this.lotId
        }

        let endpoint = `automation/terms/compute`
        if (this.termsId && (this.termsId > 0)) {
            endpoint = `automation/terms/${this.termsId}/compute`
        }

        this.master.post(endpoint, payload, (res) => {
            if (!res || !res.data) {
                this.ms.sendMessage("alert", { type: "danger", text: this.words[this.language]['apiNoResponse'] });
            return
            }
  
            if (res.status !== 200) {
                this.ms.sendMessage("alert", { type: "danger", text: res.data.error });
                return
            }

            this.recomputed.emit(payload)
        })
    }
}
